








import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import EventScheduleOfferResourceList from '@ui/EventSchedule/EventScheduleOfferResourceList'
import ExportOffersCSVTriggerModal from '@triggers/Offers/ExportOffersCSVTriggerModal'

settings =
  name: "CampaignSchedule"

  resources:
    campaign:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'

    event_schedule:
      resourceName: 'event_schedule'
      slug: 'campaigns/:campaignId/event_schedule'

    offers:
      resourceName: 'offer'
      slug: 'campaigns/:campaignId/offers'
      infinityScroll: true

  vue:
    props: ['campaignId', 'resourceSlug']
    components: { Back, EventScheduleOfferResourceList, ExportOffersCSVTriggerModal }

    computed:
      offerStats: -> @ctxStats(@event_schedule).offer

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      exportOffersCSVTrigger: ->
        @$refs.exportOffersCSVTrigger.fire()
      onOffersDownloadOffers: ->
        @$refs.exportOffersCSVTrigger.close()

export default VueOptions.vue settings
